import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';

const key = 'pacingGraph';

type CurrentGoal = {
    startDate: string;
    endDate: string;
    targetValue: number;
    currentValue: number;
    metricUpdatedAt: string;
    description: { label: string };
    statusId: number;
};

const fetchGoal = async (
    key: string,
    clientId: string,
    goalId: string,
    token: string,
    userId: string,
): Promise<CurrentGoal> => {
    return sportsApi
        .url(`/clients/${clientId}/goals/${goalId}`)
        .headers({
            'x-auth-token': token,
            'x-client-id': clientId,
            'x-auth-user-id': userId,
            'content-type': 'application/json',
        })
        .get()
        .json();
};

const usePacingGraph = ({
    clientId,
    goalId,
    token,
    userId,
}: {
    clientId: string;
    goalId: string;
    token: string;
    userId: string;
}) =>
    useQuery({
        queryKey: [key, clientId, goalId, token, userId],
        queryFn: () => fetchGoal(key, clientId, goalId, token, userId),
    });

export default usePacingGraph;
